module.exports = __webpack_public_path__ + "static/media/info.42023803.svg";